import { message } from "antd"
import {
  getUploadFailureMessages,
  type UploadLocalResourceFailure,
} from "~/common/media/resourceUpload"
import { isAbortError } from "~/common/utils"

export const notifyUploadSuccess = (count: number) => {
  if (!count) return
  void message.success(count > 1 ? `已上传 ${count} 个素材` : "已上传素材")
}

// 同类错误去重后逐条提示，用户主动取消的上传不提示
export const notifyUploadFailures = (
  failures: UploadLocalResourceFailure[],
  fallbackMessage?: string,
) => {
  getUploadFailureMessages(
    failures.filter(({ error }) => !isAbortError(error)),
    fallbackMessage,
  ).forEach((errorMessage) => {
    void message.error(errorMessage)
  })
}
